import GraphObject, { type GraphObjectProps } from './object'

import 'components/graph/edge.less'

type EdgeProps = Omit<GraphObjectProps, 'objectType' | 'objectAttrs' | 'showMetaDepth'> & Record<string, unknown>

const EDGE_ATTRS = ['from', 'to', 'directionality']

const Edge = (props: EdgeProps) => (
  <GraphObject {...props} objectType="edge" objectAttrs={EDGE_ATTRS} showMetaDepth={1} />
)

export default Edge
